import type { ComponentProps } from 'react';

import { SelectField as UadSelectField } from '@iconik-io/uad';

import { useFieldContext } from '../app_form_context';
import { getFieldErrorMessage } from '../get_field_error_message';

type UadSelectFieldProps = ComponentProps<typeof UadSelectField>;

export type SelectFieldProps = Omit<
  UadSelectFieldProps,
  'name' | 'value' | 'onChange' | 'isInvalid' | 'errorMessage'
>;

export function SelectField(props: SelectFieldProps) {
  const { options, ...rest } = props;
  const field = useFieldContext<string | undefined>();
  const isInvalid = field.state.meta.isTouched && !field.state.meta.isValid;

  return (
    <UadSelectField
      name={field.name}
      isInvalid={isInvalid}
      errorMessage={
        isInvalid ? getFieldErrorMessage(field.state.meta.errors) : undefined
      }
      options={options}
      value={field.state.value ?? null}
      onChange={(value) => {
        if (typeof value === 'string') {
          field.setValue(value);
        } else {
          field.setValue(undefined);
        }
      }}
      {...rest}
    />
  );
}
